import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ItemSetItem {
  _id: string;
  id?: number;
  name?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class ItemSetService {
  private readonly apiUrl: string = '/api/item-sets'; 

  constructor(private http: HttpClient) {}

  async getAllItemSets(): Promise<any[]> {
    const payload = { query: {} }; 
    return firstValueFrom(this.http.post<any[]>(`${this.apiUrl}/list`, payload));
  }

  async getOptimizedItemSets(): Promise<any[]> {
    const payload = { query: {} };
    return firstValueFrom(this.http.post<any[]>(`${this.apiUrl}/list-optimized`, payload));
  }

  async loadItemSetThumbnails(id: number): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiUrl}/load-thumbnails/${id}`, {}));
  }

  async getItemSet(id: number): Promise<any> {
    return await firstValueFrom(this.http.get<any>(`${this.apiUrl}/${id}`));
  }

  async addToItemSet(payload: any): Promise<any> {
    return await firstValueFrom(this.http.post(`${this.apiUrl}/add-items-to-set`, payload));
  }

  async createItemSet(payload: any): Promise<any> {
    return await firstValueFrom(this.http.post(`${this.apiUrl}/create-item-set`, payload));
  }
  
  async findSimilarItems(payload: any): Promise<any> {
    return await firstValueFrom(this.http.post(`${this.apiUrl}/find-similar-items`, payload));
  }
  async moveToItemSet(itemSetId: number, items: any[], currentItemSetId: number): Promise<void> {
    try {
      console.log('Moving items to set:', { itemSetId, items, currentItemSetId });
      const url = `${this.apiUrl}/${itemSetId}/move`;
      const response = await firstValueFrom(
        this.http.post<any>(url, { items, currentItemSetId }, {
          headers: { 'Content-Type': 'application/json' }
        })
      );
      console.log('Move response:', response);
    } catch (error: any) {
      console.error('Error in moveToItemSet:', error);
      throw new Error(error.error?.message || 'Failed to move items');
    }
  }
  async copyToItemSet(itemSetId: number, items: any[]): Promise<void> {
    try {
      console.log('Copying items to set:', { itemSetId, items });
      const url = `${this.apiUrl}/${itemSetId}/copy`;
      const response = await firstValueFrom(
        this.http.post<any>(url, { items }, {
          headers: { 'Content-Type': 'application/json' }
        })
      );
      console.log('Copy response:', response);
    } catch (error: any) {
      console.error('Error in copyToItemSet:', error);
      throw new Error(error.error?.message || 'Failed to copy items');
    }
  }
  


  async updateItemSet(id: number, updateDto: any): Promise<any> {
    const url = `${this.apiUrl}/update/${id}`;
    return firstValueFrom(this.http.patch(url, updateDto));
  }

  async setInProgressState(id: number, inProgress: boolean): Promise<void> {
    const url = `${this.apiUrl}/set-progress-state`;
    await firstValueFrom(this.http.post<void>(url, { id, inProgress }));
  }

  async findItemSetWithItems(id: number): Promise<any> {
    const payload = { query: { id } };
    return firstValueFrom(this.http.post<any>(`${this.apiUrl}/find`, payload));
  }

}
